/**
 * Rota-pai do ambiente Administração — D5 (30/Set/2026, prancha 00-B/2a).
 *
 * De 22/Ago a 30/Set este arquivo desenhava um rail próprio (Visão geral + 6 domínios +
 * Gestão) ao lado do menu principal — «uma página dentro de outra página», nas palavras
 * do TL. Os domínios agora vivem na seção «Administração» do `nav-model.ts` (lida do
 * catálogo) e as ferramentas no fim de cada `DomainPage`. Aqui sobra o que uma rota-pai
 * precisa: o container de rolagem e o `<Outlet/>`. Os redirects das rotas antigas de
 * /admin/* seguem em `adminRoutes()` (App.tsx) — nada quebra.
 */
import { Outlet } from 'react-router-dom';

export function AdminShell(): JSX.Element {
  // `overflow-hidden` no casco + rolagem no <main>: sem isso a página de domínio rola o
  // documento inteiro e leva a topbar junto (medido no smoke de 30/Set com `#ferramentas`).
  return (
    <div className="flex h-full overflow-hidden">
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
